module.exports = __webpack_public_path__ + "img/CattleyaoneHandedSword_06.ba9d11be.png";